var _defs, _rect, _g, _rect2, _rect3, _path, _rect4, _path2, _rect5, _g2, _rect6, _rect7, _path3, _rect8, _path4, _g3, _g4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.06,
    height: 98.114,
    viewBox: "0 0 103.06 98.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0e0e0;}.b,.k{opacity:0.5;}.c{fill:url(#a);}.d{fill:#fafafa;}.e{fill:url(#b);}.f{fill:url(#c);}.g,.k{fill:#c2c2c2;}.h{fill:url(#d);}.i{fill:#fff;}.j{fill:url(#f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.509,
    y1: 0.997,
    x2: 0.509,
    y2: -0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.813,
    y1: 0.841,
    x2: 0.813,
    y2: -0.159,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.78,
    y1: 0.849,
    x2: 1.78,
    y2: -0.151,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 0.999,
    x2: 0.5,
    y2: -0.001,
    xlinkHref: "#a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 54.914,
    height: 75.874,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 8.686, 17.025)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(9.863 6.954)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 53.059,
    height: 73.309,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 0, 11.131)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 51.708,
    height: 71.69,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 10.636, 18.471)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 25.652,
    height: 6.214,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 22.788, 12.685)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M441.307,91.352a3.672,3.672,0,1,0,4.272,2.837A3.629,3.629,0,0,0,441.307,91.352Zm1.215,5.667a2.119,2.119,0,1,1,1.578-2.513,2.093,2.093,0,0,1-1.578,2.513Z",
    transform: "translate(-407.253 -87.292)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 25.111,
    height: 5.94,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 22.996, 12.367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M441.629,91.351a3.51,3.51,0,1,0,4.168,2.7A3.51,3.51,0,0,0,441.629,91.351Zm1.161,5.416a2.026,2.026,0,1,1,1.556-2.405A2.026,2.026,0,0,1,442.79,96.767Z",
    transform: "translate(-407.575 -87.291)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 54.914,
    height: 75.874,
    transform: "translate(32.406 14.691)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(33.334 15.973)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 53.059,
    height: 73.309
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 51.708,
    height: 71.69,
    transform: "translate(34.009 16.514)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 25.652,
    height: 6.214,
    transform: "translate(47.105 13.405)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M641.906,118a3.673,3.673,0,1,0,3.586,3.672A3.63,3.63,0,0,0,641.906,118Zm0,5.79a2.119,2.119,0,1,1,2.068-2.119,2.093,2.093,0,0,1-2.068,2.109Z",
    transform: "translate(-581.976 -110.66)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 25.111,
    height: 5.94,
    transform: "translate(47.375 13.139)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M642.44,118a3.51,3.51,0,1,0,3.51,3.51A3.51,3.51,0,0,0,642.44,118Zm0,5.535a2.027,2.027,0,1,0,0-.006Z",
    transform: "translate(-582.509 -110.66)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0.816 92.615)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.472,
    height: 2.68,
    transform: "translate(1.103)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.472,
    height: 2.68,
    transform: "translate(2.68 1.105) rotate(90)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(55.629)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.472,
    height: 2.68,
    transform: "translate(1.103)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 0.472,
    height: 2.68,
    transform: "translate(2.68 1.103) rotate(90)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M947.527,824.693a.579.579,0,0,1-.323-.7.278.278,0,0,0,.013-.064h0a.29.29,0,0,0-.522-.192h0a.293.293,0,0,0-.033.057.579.579,0,0,1-.7.323.278.278,0,0,0-.064-.013h0a.29.29,0,0,0-.192.521h0a.281.281,0,0,0,.057.033.579.579,0,0,1,.323.7.271.271,0,0,0-.013.064h0a.29.29,0,0,0,.521.192h0a.274.274,0,0,0,.033-.057.579.579,0,0,1,.7-.323.278.278,0,0,0,.064.013h0a.29.29,0,0,0,.192-.522h0A.274.274,0,0,0,947.527,824.693Z",
    transform: "translate(-850.636 -727.615)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M313.117,619.633a.579.579,0,0,1-.323-.7.277.277,0,0,0,.013-.064h0a.29.29,0,0,0-.521-.192h0a.277.277,0,0,0-.033.056.579.579,0,0,1-.7.323.287.287,0,0,0-.064-.013h0a.29.29,0,0,0-.192.522h0a.285.285,0,0,0,.057.033.579.579,0,0,1,.323.7.282.282,0,0,0-.013.064h0a.29.29,0,0,0,.521.192h0a.278.278,0,0,0,.033-.057.579.579,0,0,1,.7-.323.279.279,0,0,0,.064.012h0a.29.29,0,0,0,.192-.521h0A.276.276,0,0,0,313.117,619.633Z",
    transform: "translate(-295.944 -548.323)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M841.527,120.313a.579.579,0,0,1-.323-.7.279.279,0,0,0,.012-.064h0a.29.29,0,0,0-.521-.192h0a.274.274,0,0,0-.033.057.579.579,0,0,1-.7.323.282.282,0,0,0-.064-.013h0a.29.29,0,0,0-.192.521h0a.279.279,0,0,0,.057.033.579.579,0,0,1,.323.7.28.28,0,0,0-.013.064h0a.29.29,0,0,0,.521.192h0a.281.281,0,0,0,.033-.057.579.579,0,0,1,.7-.323.279.279,0,0,0,.064.013h0a.29.29,0,0,0,.192-.521h0A.279.279,0,0,0,841.527,120.313Z",
    transform: "translate(-757.955 -111.745)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 0.946,
    cy: 0.946,
    rx: 0.946,
    ry: 0.946,
    transform: "translate(101.167 38.569)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 0.946,
    cy: 0.946,
    rx: 0.946,
    ry: 0.946,
    transform: "translate(28.047 92.875)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 0.946,
    cy: 0.946,
    rx: 0.946,
    ry: 0.946,
    transform: "translate(91.45 59.021)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 0.946,
    cy: 0.946,
    rx: 0.946,
    ry: 0.946,
    transform: "translate(10.004 11.161)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 0.946,
    cy: 0.946,
    rx: 0.946,
    ry: 0.946,
    transform: "translate(0 36.972)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPad);
export default __webpack_public_path__ + "static/media/pad.6b6eb9132b3b4f92324f1bc083b8e500.svg";
export { ForwardRef as ReactComponent };